const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function Svg16IconoAgregarempresa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7cdab8;}")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Agregar_empresa",
    "data-name": "Agregar empresa"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.3,15.7a.42.42,0,0,1-.3.13.42.42,0,0,1-.42-.43v-5h-5a.42.42,0,1,1,0-.84H10a.42.42,0,0,1,.42.42v5.4A.39.39,0,0,1,10.3,15.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.7,10.3a.39.39,0,0,1-.3.12H10A.42.42,0,0,1,9.58,10V4.6a.42.42,0,1,1,.84,0v5h5a.42.42,0,0,1,.43.42A.42.42,0,0,1,15.7,10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.58,20H.42A.42.42,0,0,1,0,19.58V.42A.42.42,0,0,1,.42,0H19.58A.42.42,0,0,1,20,.42V19.58A.42.42,0,0,1,19.58,20ZM.85,19.15h18.3V.85H.85Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16IconoAgregarempresa);
export default __webpack_public_path__ + "static/media/16_Icono_Agregar empresa.4a8f69630461e2f05c1d7354ad75ee91.svg";
export { ForwardRef as ReactComponent };